import React from "react";

const PdfViewerControls = ({
  currentPageNumber,
  totalPdfPages,
  zoomLevel,
  handleSelectZoom,
}) => {
  if (currentPageNumber <= 0 || totalPdfPages <= 0) {
    return null;
  }

  return (
    <div className="d-flex mr-2">
      <div style={{ color: "#757575" }}> Page:&nbsp;</div>
      <div>
        {currentPageNumber} of {totalPdfPages}
      </div>
      <div style={{ color: "#757575", marginLeft: "8px" }}>
        <label htmlFor="zoom-select">Zoom:&nbsp;</label>
        <select
          id="zoom-select"
          value={zoomLevel}
          onChange={(e) => handleSelectZoom(e.target.value)}
          className="pdf-zoom-controls"
        >
          <option value="0.75">75%</option>
          <option value="0.8">80%</option>
          <option value="0.85">85%</option>
          <option value="0.9">90%</option>
          <option value="0.95">95%</option>
          <option value="1">100%</option>
          <option value="1.25">125%</option>
          <option value="1.5">150%</option>
          <option value="1.75">175%</option>
          <option value="2">200%</option>
          <option value="2.25">225%</option>
          <option value="2.5">250%</option>
          <option value="2.75">275%</option>
          <option value="3">300%</option>
        </select>
      </div>
    </div>
  );
};

export default PdfViewerControls;
